var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bers-payment-summary"},[_c('intro',{attrs:{"headline":_vm.i18n('summary')}}),_c('bersSummary',_vm._b({},'bersSummary',_vm.customerDateTime,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }